import { createReducer } from '@reduxjs/toolkit';

import { AlertManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type AlertsState = {
    list: Loadable<{ results: AlertManager.Alert[]; totalCount: number }>;
    alertAckResponse: Loadable<AlertManager.Alert>;
    alertDetails: Loadable<AlertManager.Alert>;
};

const initialState: AlertsState = {
    list: { status: 'idle' },
    alertAckResponse: { status: 'idle' },
    alertDetails: { status: 'idle' },
};

export const [getAlertList, setAlertList] = makeThunkFromAPICall(
    AlertManager.listAlerts,
    'Alert/list',
);

export const [getAlert, setAlert] = makeThunkFromAPICall(
    AlertManager.getAlertById,
    'Alert/alert',
);

export const [getNext, setNext] = makeThunkFromAPICall(
    AlertManager.getNextAlerts,
    'Alert/next',
);

export const [sendUpdateAlertAck, setUpdateAlertAckResponse] =
    makeThunkFromAPICall(AlertManager.updateAlertAck, 'Alerts/change-ack');

export const alertsReducer = createReducer(initialState, (builder) => {
    builder.addCase(setAlertList, (state, action) => {
        return {
            ...state,
            list: { ...state.list, ...action.payload.loadable },
        };
    });
    builder.addCase(setAlert, (state, action) => {
        return {
            ...state,
            alertDetails: { ...state.alertDetails, ...action.payload.loadable },
        };
    });
    builder.addCase(setUpdateAlertAckResponse, (state, action) => {
        if (state.list.object == null) {
            return {
                ...state,
                alertAckResponse: action.payload.loadable,
            };
        }
        return {
            ...state,
            list: {
                ...state.list,
                object: {
                    ...state.list.object,
                    results: state.list.object?.results.map((alert) => {
                        if (alert.id === action.payload.loadable.object?.id) {
                            return {
                                ...alert,
                                acknowledged:
                                    action.payload.loadable.object
                                        ?.acknowledged,
                            };
                        }
                        return alert;
                    }),
                },
            },
            alertAckResponse: action.payload.loadable,
        };
    });
});

export const alertsActions = {
    getAlertList,
    setAlertList,
    getNext,
    setNext,
    sendUpdateAlertAck,
    getAlert,
};

export default alertsReducer;
